<template>
  <form class="flex w-full overflow-x-hidden" id="form-activity" autocomplete="off" >
    <div class="w-full p-2" >
      <div class="flex px-4 mb-2">
        <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
          Cover Image <span class="text-red-500">*</span>
        </label>
      </div>
      <div class="flex flex-col items-center mb-6">
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="input.artwork?input.artwork:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">We'll crop your image to a 900×900 square.</p>
          <p v-if="isImageTooSmall" class="text-xs text-orange-600 mt-1">Image is smaller than 900×900; quality may be reduced.</p>
        </div>
        <div class="flex flex-col mb-2" v-if="$v.input.artwork.$dirty && !$v.input.artwork.required">
          <text-error v-if="$v.input.artwork.$dirty && !$v.input.artwork.required" text="Please select album artwork." />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!input.artwork">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="profile_picture"
                     accept="image/*"
                     @change="onFileChange"
              />
            </template>
          </Button>
          <Button label="Cancel" variant="default" v-if="input.artwork" @clicked="changeImage"></Button>
        </div>
        <ImageCropModal
          :show="showCropModal"
          :imageSrc="pendingImageSrc"
          @cropped="onCropCropped"
          @cancel="onCropCancel"
        />
      </div>
      <div class="flex px-4 mb-2 mt-8">
        <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
          Metadata
        </label>
      </div>
      <form-item label='Album Name' :required="true" class="mt-6">
        <Input
          v-model="input.albumName"
          placeholder="ex. Album Name"
          :error="$v.input.albumName.$dirty && (!$v.input.albumName.required || !$v.input.albumName.maxLength)"
          maxlength="100"
        />
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.albumName.$dirty && !$v.input.albumName.required" text="Please fill Album Name." />
          <text-error v-if="$v.input.albumName.$dirty && !$v.input.albumName.maxLength" text="Max length Album name is 100 character." />
        </div>
      </form-item>
      <form-item label='Description' :required="true" class="mt-6">
        <div class="relative">
            <TextArea
              v-model="input.albumDescription"
              placeholder="Description Video"
              :error="$v.input.albumDescription.$dirty && (!$v.input.albumDescription.required || !$v.input.albumDescription.maxLength)"
              rows="5"
            />
          <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{input.albumDescription.length}}/{{maxLengthDesc}}</div>
        </div>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.albumDescription.$dirty && !$v.input.albumDescription.required" text="Please fill the Description." />
          <text-error v-if="$v.input.albumDescription.$dirty && !$v.input.albumDescription.maxLength" text="Max length description channel is 1000 character" />
        </div>
      </form-item>
      <form-item label='Year' :required="true" class="mt-6">
        <Input
          v-model="input.year"
          placeholder="ex. 2020"
          :error="$v.input.year.$dirty && (!$v.input.year.required || !$v.input.year.maxLength || !$v.input.year.numeric)"
          maxlength="100"
        />
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.year.$dirty && !$v.input.year.required" text="Please fill Year Album." />
          <text-error v-if="$v.input.year.$dirty && !$v.input.year.maxLength" text="Max length Year Album is 4 character." />
          <text-error v-if="$v.input.year.$dirty && !$v.input.year.numeric" text="Please fill Year Album with number." />
        </div>
      </form-item>
      <form-item label='Category' :required="true" class="mt-6">
        <template v-slot>
          <div class="flex flex-col">
            <div class="flex flex-col mb-4" v-for="(v, index) in $v.input.genreList.$each.$iter" :key="'genre-' + index">
              <div class="flex">
                <select
                  class="border border-1 px-3 py-2 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150"
                  v-bind:class="{ 'border-red-500': v.id.$dirty && !v.id.required }"
                  v-model="v.id.$model"
                >
                  <option :value="null" disabled >Select Song Category</option>
                  <option
                    v-for="(item, key) in listGenreSong"
                    :key="key"
                    :value="item.id"
                    :v-text="item.name"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <button v-if="index > 0" type="button" @click="removeCategory(index)" class="w-10 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                  <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                </button>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="v.id.$dirty && !v.id.required" text="Please choose category" />
              </div>
            </div>
            <div class="flex w-full justify-center">
              <a @click="addCategory"
                 class="text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-700 hover:text-blue-100
                          text-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Add another category</a>
            </div>
          </div>
        </template>
      </form-item>
      <form-item label='Language' :required="isArtist" class="mt-6">
        <template v-slot>
          <el-select v-model="input.language" filterable placeholder="Select Language" class="w-full">
            <el-option
              v-for="item in dataLanguages"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="flex flex-col pt-2">
            <text-error v-if="$v.input.language.$dirty && !$v.input.language.required" text="Please choose language." />
          </div>
        </template>
      </form-item>
      <form-item label='Composer (optional)' class="mt-6">
        <Input
          v-model="input.composer"
          placeholder="ex. Composer name(s)"
          maxlength="255"
        />
      </form-item>
      <div class="flex flex-wrap px-4 mb-2 mt-8">
        <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
          Monetization
        </label>
      </div>
      <form-item label='Subscription' info="Turn on and off subscription setting to monetize this content by streaming number." class="mt-6">
        <template v-slot>
          <label
            for="toogleSubsEditAlbum"
            class="flex items-center cursor-pointer"
          >
            <!-- toggle -->
            <div class="relative">
              <!-- input -->
              <input id="toogleSubsEditAlbum" type="checkbox" v-model="input.isSubscription" class="hidden"  />
              <!-- line -->
              <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
              <!-- dot -->
              <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
            </div>
            <!-- label -->
            <div class="ml-3 text-gray-700 font-medium" >
              {{ input.isSubscription ? 'On' : 'Off' }}
            </div>
          </label>
        </template>
      </form-item>
      <form-item label='Sell Album' info="toggle between free and paid to monetize this content by selling it" class="mt-6">
        <template v-slot>
          <label
            for="toogleBEditAlbum"
            class="flex items-center cursor-pointer"
          >
            <!-- toggle -->
            <div class="relative">
              <!-- input -->
              <input id="toogleBEditAlbum" type="checkbox" v-model="input.isPaid" class="hidden" />
              <!-- line -->
              <div
                class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
              ></div>
              <!-- dot -->
              <div
                class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
              ></div>
            </div>
            <!-- label -->
            <div
              class="ml-3 text-gray-700 font-medium"
            >
              {{ input.isPaid ? 'Paid' : 'Free' }}
            </div>
          </label>
        </template>
      </form-item>
      <form-item v-if="input.isPaid" label='Album Price (USD)' :required="input.isPaid" class="mt-6">
        <div class="inline-flex w-full gap-4 items-center">
          $ <Input
          v-model="input.price"
          placeholder="ex. 5"
          :error="$v.input.price.$dirty && (!$v.input.price.required  || !$v.input.price.decimal)"
        /> = {{ creditPrice }} Credits
        </div>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.price.$dirty && !$v.input.price.required" text="Please fill Album Price." />
          <text-error v-if="$v.input.price.$dirty && !$v.input.price.decimal" text="Please fill Album Price with number." />
        </div>
      </form-item>
      <div class="flex w-full mt-6" v-if="input.isPaid && input.price != 0">
        <div class="w-1/2">
          <form-item  label='MusicVerse Cut'>
            <p class="text-left font-bold">$ {{ priceMusicVerse }}</p>
          </form-item>
        </div>
        <div class="w-1/2">
          <form-item  label='Artist Cut'>
            <p class="text-left font-bold">$ {{ priceArtistMusicVerse }}</p>
          </form-item>
        </div>
      </div>
      <form-item  label='Sell Song Individually?' info="When you upload a song, you can put price individually in each track" class="mt-6">
        <Select
          v-model="input.isSellSongIndividually"
          empty-label=""
          :data="[{value:0,label:'No'},{value:1,label:'Yes'}]"
        />
      </form-item>
      <form-item  label='Copyright' class="mt-6">
        <label
          for="toogleCopyRightEditAlbum"
          class="flex items-center cursor-pointer"
        >
          <!-- toggle -->
          <div class="relative">
            <!-- input -->
            <input id="toogleCopyRightEditAlbum" type="checkbox" v-model="input.copyRight" class="hidden"  />
            <!-- line -->
            <div
              class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
            ></div>
            <!-- dot -->
            <div
              class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
            ></div>
          </div>
          <!-- label -->
          <div
            class="ml-3 text-gray-700 font-medium"
          >
            {{ input.copyRight ? 'Yes' : 'No' }}
          </div>
        </label>
      </form-item>
      <form-item v-if="input.copyRight" label='Upload Copyright' :required="input.copyRight" class="mt-6">
        <input
          v-if="!input.copyRightFile"
          type="file"
          class="block border border-grey-light w-full p-3 rounded"
          name="copyright_file"
          @change="onFileChangeCopyRight"
          accept="image/*,application/pdf,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
        />
        <div v-if="input.copyRightFile" class="flex" >
          <span class="mr-2 text-gray-700 font-medium">{{copyRightFileName}}</span>
          <a @click="changeCopyRight" ><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
        </div>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.input.copyRightFile.$dirty && !$v.input.copyRightFile.required" text="Please select copyright file." />
        </div>
      </form-item>
      <div class="flex flex-wrap px-4 mb-2 mt-8">
        <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
          Upload Tracks <span class="text-red-500">*</span>
        </label>
        <p v-if="isErrorMusicCount" class="text-red-500 text-xs italic w-full">You must upload at least 1 song.</p>
      </div>
      <div v-if="input.musics.length>0">
        <div class="flex flex-col mb-2" v-for="(v, index) in $v.input.musics.$each.$iter">
          <div class="flex flex-wrap mt-4 mb-2">
            <div class="px-4 mb-1 md:mb-0">
              <label class="block uppercase tracking-wide text-gray-700  font-bold mb-2" >
                Track {{ parseInt(index)+1}} <span class="text-red-500">*</span>
                <button type="button" @click="removeTracks(index)" class="w-6 ml-2 p-1 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                  <font-awesome-icon class="text-white" size="1x" :icon="['fa', 'trash-alt']" />
                </button>
              </label>
            </div>
          </div>
          <form-item label='Track Number' :required="true" class="mt-6">
            <template v-slot>
              <select
                type="text"
                class="block border border-grey-light w-full p-3 rounded mb-4"
                v-model.trim="input.musics[index].track_number"
                @change="changeTrackNumber($event,index)"
              >
                <option
                  v-for="(item, key) in listTrackNumbers"
                  :key="key"
                  :value="item"
                  :v-text="item"
                >
                  {{ item }}
                </option>
              </select>
            </template>
          </form-item>
          <form-item label='Name' :required="true" class="mt-6">
            <Input
              v-model.trim="v.title.$model"
              placeholder="Song Name"
              :error="v.title.$dirty && !v.title.required"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="v.title.$dirty && !v.title.required" text="Please fill Song Name." />
            </div>
          </form-item>
          <form-item label='File' class="mt-6">
            <div class="flex" v-if="input.musics[index].fileMusicPreview" >
              <audio ref="audioFile" controls="controls">
                <source :src="input.musics[index].fileMusicPreview" type="audio/mp3">
              </audio>
            </div>
          </form-item>
          <form-item label='Lyric' class="mt-6">
            <input
              v-if="!v.lyric.$model"
              type="file"
              class="block border border-grey-light w-full p-3 rounded"
              name="lyrics_file"
              @change="v.lyricFile.$model = $event.target.files[0];v.lyric.$model = v.lyricFile.$model.name"
              accept=".srt"
            />
            <div v-if="v.lyric.$model" class="flex" >
              <span class="mr-2 text-gray-700 font-medium">{{v.lyric.$model}}</span>
              <a @click="v.lyric.$model = null" ><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
            </div>
            <div class="flex flex-col pt-2">
              <text-error v-if="v.lyricFile.$dirty && !v.lyricFile.mustSrt" text="File type must be .srt" />
            </div>
          </form-item>
          <form-item label='Language' :required="isArtist" class="mt-6">
            <el-select v-model="v.language.$model" filterable placeholder="Select Language" class="w-full">
              <el-option
                v-for="item in dataLanguages"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <div class="flex flex-col pt-2">
              <text-error v-if="v.language.$dirty && !v.language.required && isArtist" text="Please choose language." />
            </div>
          </form-item>
          <form-item label='Composer (optional)' class="mt-6">
            <Input
              v-model.trim="v.composer.$model"
              placeholder="ex. Composer name(s)"
              maxlength="255"
            />
          </form-item>
          <form-item label='Original or Cover Song' class="mt-6">
            <Select
              v-model="v.is_cover.$model"
              empty-label=""
              :data="[{value:0,label:'Original'},{value:1,label:'Cover'}]"
            />
          </form-item>
          <form-item v-if="input.musics[index].is_cover === 1" label='Original Artist Name' :required="input.musics[index].is_cover === 1" class="mt-6">
            <Input
              v-model.trim="v.original_artist_name.$model"
              placeholder="Original artist name"
              maxlength="255"
            />
            <div class="flex flex-col pt-2">
              <text-error v-if="isErrorCoverArtist[index]" text="Please fill Original Artist Name for a Cover song." />
            </div>
          </form-item>
          <form-item v-if="input.musics[index].is_cover === 1" label='Original Artist Info' class="mt-6">
            <TextArea
              v-model.trim="v.original_artist_info.$model"
              placeholder="Original artist info (optional)"
              rows="3"
            />
          </form-item>
          <form-item v-if="input.isSellSongIndividually" label='Song Price' class="mt-6">
            <div class="inline-flex w-full gap-4 items-center">
              $ <input
              class="border border-1 px-3 py-3 placeholder-gray-500 text-gray-700 bg-white disabled:bg-gray-600 rounded text-sm shadow focus:outline-none w-full ease-linear transition-all duration-150"
              v-model="v.price.$model"
              @keyup="convertPrice(index)"
              placeholder="ex. 5"
            /> = {{ input.musics[index].price_dollar }} Credits
            </div>
          </form-item>
        </div>
      </div>
      <div class="flex flex-wrap -mx-3 mt-4 mb-2">
        <div ref="dragDrop"
             class="relative drag-drop px-3 w-full upload-btn-wrapper"
             @drop.prevent="onDrop($event)"
             @dragover.prevent="dragover = true"
             @dragenter.prevent="dragover = true"
             @dragleave.prevent="dragover = false"
        >
          <input type="file" name="fileSongEdit" @change="onFileUploadSong" />
          <div class="absolute drag-drop-content flex flex-col w-full">
            <font-awesome-icon  :icon="['fa', 'cloud-upload-alt']" class="icon-drag-drop" /><br />
            <span>Click or Drag Your Files Here</span>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, numeric, decimal, maxLength, minLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import helpersMixin from '../../mixins/helpers.mixins';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';
import ImageCropModal from '@/components/Common/ImageCropModal.vue';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

const API_URL = process.env.API_URL;
const mustSrt = (value) => {
  if(!!value){
    const fileSplit = value.name.split('.');
    const ext = fileSplit[fileSplit.length - 1];
    return ext==='srt'
  }
  return true;
}
export default {
  name: 'EditAlbum',
  mixins: [validationMixin, helpersMixin],
  props: {
    toggleReset: {
      type: Boolean,
      default: () => false,
    },
    albumId: {
      type: Number,
    },
    musicverseCut: {
      type: Number,
      default: () => 70,
    },
    artistCut: {
      type: Number,
      default: () => 30,
    },
  },
  data() {
    return {
      maxLengthDesc: 1000,
      dataLanguages: [],
      dragover: false,
      uploadedFiles: [],
      isError: false,
      isErrorMusicCount: false,
      isErrorCoverArtist: {},
      showCropModal: false,
      pendingImageSrc: null,
      isImageTooSmall: false,
      album: {
        name: '',
        year: '',
        price: '',
        cover: null,
        copyright: null,
        content: [],
        is_paid: 0,
        is_subscription: 0,
        sell_song_individually: 0,
        language: null,
        description: '',
        genre_id: null,
      },
      input: {
        albumName: '',
        albumDescription: '',
        year: '',
        genre: '',
        price: '',
        artwork: null,
        copyRight: null,
        copyRightFile: null,
        composer: '',
        musics: [],
        isPaid: false,
        isSubscription: false,
        isSellSongIndividually: 0,
        language: null,
        genreList: []
      },
      copyRightFileName: '',
      listLanguage: [{
        id: 'Bahasa Indonesia',
        name: 'Bahasa Indonesia',
      }, {
        id: 'Malay',
        name: 'Malay',
      }, {
        id: 'Tagalog',
        name: 'Tagalog',
      }, {
        id: 'English',
        name: 'English',
      }],
      listTrackNumbers: [],
      orderedTrackNumber: [],
      deletedTrack: [],
      imgPlaceholder
    };
  },
  validations() {
    const rules = {
      input: {
        artwork: {
          required,
        },
        albumName: {
          required,
          maxLength: maxLength(100),
        },
        albumDescription: {
          required,
          maxLength: maxLength(1000),
        },
        genreList: {
          required,
          minLength: minLength(1),
          $each: {
            id: {
              required,
            },
          },
        },
        year: {
          required,
          numeric,
          maxLength: maxLength(4),
        },
        language: {},
      },
    };
    if (this.isArtist) {
      rules.input.language = {
        required,
      };
    }
    if (this.input.isPaid) {
      rules.input.price = {
        required,
        decimal,
      };
    }
    if (this.input.copyRight) {
      rules.input.copyRightFile = {
        required,
      };
    }
    if (this.input.musics.length > 0) {
      rules.input.musics = {
        required,
        minLength: minLength(1),
        $each: {
          title: {
            required,
          },
          track_number: {
            required,
          },
          language: {},
          composer: {},
          is_cover: {},
          original_artist_name: {},
          original_artist_info: {},
          lyricFile: {mustSrt},
          lyric: {},
          price: {
            decimal,
          },
        },
      };
      if (this.isArtist) {
        rules.input.musics.$each.language = {
          required,
        };
      }
    }
    return rules;
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isArtist', 'isFinance', 'isOps', 'isReviewer', 'isRecruitment', 'getUser', 'accessToken', 'tokenType']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('SongModule', [
      // 'getPercentageUpload',
      'listGenreSong',
    ]),
    priceMusicVerse() {
      return !isNaN(this.input.price) ? parseFloat(this.input.price * (this.musicverseCut / 100)).toFixed(2) : 0;
    },
    creditPrice() {
      return !isNaN(this.input.price) ? parseFloat(this.toCredit(this.input.price)).toFixed(2) : 0;
    },
    priceArtistMusicVerse() {
      return !isNaN(this.input.price) ? parseFloat(this.input.price * (this.artistCut / 100)).toFixed(2) : 0;
    },
  },
  watch: {
    toggleReset: {
      immediate: true,
      async handler(val) {
        if (val) {
          await this.resetState();
        }
      },
    },
  },
  methods: {
    ...mapActions('AlbumModule', [
      'requestGetTagsAlbum',
      'requestEditAlbumAdmin',
      'requestEditAlbumAdminStream',
      'requestUpdateAlbum',
      'requestDetailAlbum',
    ]),
    ...mapActions('SongModule', [
      'requestAddSongFileTemp',
      'requestGetTags',
    ]),
    ...mapActions('NotificationModule', [
      'setLoadingWithMessage',
      'unsetLoading',
    ]),
    async resetState() {
      this.$v.$reset();
      this.album = await this.requestDetailAlbum(this.albumId);
      this.isError = false;
      this.isErrorMusicCount = false;
      this.isErrorCoverArtist = {};
      this.isImageTooSmall = false;
      this.showCropModal = false;
      this.revokePendingImage();
      this.copyRightFileName = '';
      let genreList = [];
      if (this.album.content.length > 0) {
        if (this.album.content[0].genres.length > 0) {
          genreList = this.album.content[0].genres.map(c => ({
            // eslint-disable-next-line radix
            id: parseInt(c.id),
          }));
        } else if (!!this.album.content[0].genre_id) {
          genreList = this.album.content[0].genre_id.toString().split(',').map(c => ({
            // eslint-disable-next-line radix
            id: parseInt(c),
          }));
        }
      }
      const findLang = this.dataLanguages.find(lang => lang.value == this.album.language);
      this.input = Object.assign({}, {
        albumName: this.album.name,
        albumDescription: this.album.description,
        year: this.album.year,
        price: this.album.is_paid == 1 ? this.toDollar(this.album.price) : 0,
        artwork: this.album.cover,
        copyRight: !!this.album.copyright,
        copyRightFile: this.album.copyright,
        musics: [],
        composer: this.album.composer || '',
        genre: this.album.content.length > 0 ? this.album.content[0].genre_id : null,
        isPaid: this.album.is_paid == 1,
        isSubscription: this.album.is_subscription == 1,
        language: findLang != undefined ? this.album.language : null,
        isSellSongIndividually: this.album.sell_song_individually,
        genreList,
      });
      this.copyRightFileName = this.album.copyright ? 'Copyright Link' : '';
      this.listTrackNumbers = [];
      this.orderedTrackNumber = [];
      this.deletedTrack = [];
      let index = 0;
      for (const c of this.album.content) {
        const findLang = this.dataLanguages.find(lang => lang.value == c.language);
        this.input.musics.push({
          content_id: c.content_id,
          id: c.id,
          type: 'old',
          title: c.title,
          fileMusicPreview: await this.getMusicFile(c.file),
          price: c.price > 0 ? this.toDollar(c.price) : 0,
          price_dollar: !isNaN(c.price) ? parseFloat(c.price).toFixed(2) : 0,
          track_number: index + 1,
          language: findLang != undefined ? c.language : null,
          composer: c.composer || '',
          is_cover: c.is_cover || 0,
          original_artist_name: c.original_artist_name || '',
          original_artist_info: c.original_artist_info || '',
          lyricFile: null,
          lyric: !!c.lyric ? 'lyric.srt':null,
          tag: '',
        });
        this.orderedTrackNumber.push(index + 1);
        index++;
      }
      if (this.input.musics.length > 0) {
        this.listTrackNumbers = Array.from({ length: this.input.musics.length }, (_, i) => i + 1);
      }
    },
    async submit() {
      this.$v.$touch();
      this.isErrorMusicCount = this.input.musics.length === 0;
      this.isErrorCoverArtist = {};
      const coverErrors = [];
      this.input.musics.forEach((m, index) => {
        if (m.is_cover === 1 && !m.original_artist_name) {
          coverErrors.push(index);
        }
      });
      if (coverErrors.length > 0) {
        coverErrors.forEach((index) => {
          this.$set(this.isErrorCoverArtist, index, true);
        });
      }
      if (!this.$v.$invalid && !this.isErrorMusicCount && coverErrors.length === 0) {
        const dataAlbum = new FormData();
        dataAlbum.append('id', this.albumId);
        dataAlbum.append('name', this.input.albumName);
        dataAlbum.append('description', this.input.albumDescription);
        dataAlbum.append('year', this.input.year);
        const genreList = this.input.genreList.map(g => g.id).join(',');
        dataAlbum.append('genre_id', genreList);
        dataAlbum.append('is_paid', this.input.isPaid ? 1 : 0);
        dataAlbum.append('is_subscription', this.input.isSubscription ? 1 : 0);
        dataAlbum.append('price', this.input.isPaid ? this.toCredit(this.input.price) : 0);
        dataAlbum.append('sell_song_individually', this.input.isSellSongIndividually ? 1 : 0);
        dataAlbum.append('language', this.input.language);
        dataAlbum.append('composer', this.input.composer);
        dataAlbum.append('tags', '');
        if (this.input.artwork != this.album.cover) {
          const resultImage = await axios({
            method: 'get',
            url: this.input.artwork,
            responseType: 'blob',
          }).then(this.processFileBlob);
          dataAlbum.append('cover', resultImage);
        }
        if (this.input.copyRight && this.input.copyRightFile != this.album.copyright) {
          const ext = this.getExt(this.copyRightFileName);
          if (ext != 'pdf') {
            const resultCopyRight = await axios({
              method: 'get',
              url: this.input.copyRightFile,
              responseType: 'blob',
            }).then(this.processFileBlob);
            dataAlbum.append('copyright', resultCopyRight);
            dataAlbum.append('copyright_type', 'image');
          } else {
            dataAlbum.append('copyright', this.input.copyRightFile);
            dataAlbum.append('copyright_type', 'pdf');
          }
        } else if (!this.input.copyRight) {
          dataAlbum.append('copyright', '');
        }
        this.input.musics.forEach((m, index) => {
          dataAlbum.append(`content[${index}][content_id]`, m.content_id);
          dataAlbum.append(`content[${index}][id]`, m.id);
          dataAlbum.append(`content[${index}][title]`, m.title);
          dataAlbum.append(`content[${index}][track_number]`, m.track_number);
          dataAlbum.append(`content[${index}][price]`, this.input.isSellSongIndividually ? this.toCredit(m.price) : 0);
          dataAlbum.append(`content[${index}][language]`, m.language);
          dataAlbum.append(`content[${index}][composer]`, m.composer || '');
          dataAlbum.append(`content[${index}][is_cover]`, m.is_cover || 0);
          dataAlbum.append(`content[${index}][original_artist_name]`, m.is_cover === 1 ? (m.original_artist_name || '') : '');
          dataAlbum.append(`content[${index}][original_artist_info]`, m.is_cover === 1 ? (m.original_artist_info || '') : '');
          dataAlbum.append(`content[${index}][tag]`, '');
          if(!!m.lyricFile){
            dataAlbum.append(`content[${index}][lyric]`, m.lyricFile);
          }
        });
        this.deletedTrack.forEach((d, index) => {
          dataAlbum.append(`deleted_content[${index}]`, d);
        });
        if (this.isArtist) {
          await this.requestUpdateAlbum(dataAlbum);
        } else {
          await this.requestEditAlbumAdminStream(dataAlbum);
        }
        if (this.getStatus == 200) {
          this.$emit('on-edit-album', true);
        } else if (this.getStatus != 200 && this.getErrorCode == 'error-edit-album') {
          this.$swal('Error', 'Something Wrong. Please Contact Admin', 'error');
        }
      }
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    onFileChange(e) {
      const file = e.target.files[0];
      e.target.value = '';
      if (!file) {
        return;
      }
      if (!file.type || !file.type.startsWith('image/')) {
        this.$swal('Error', 'Please select an image file.', 'error');
        return;
      }
      this.revokePendingImage();
      this.pendingImageSrc = URL.createObjectURL(file);
      this.showCropModal = true;
    },
    onCropCropped({ url, sourceWidth, sourceHeight }) {
      this.input.artwork = url;
      this.isImageTooSmall = Math.min(sourceWidth, sourceHeight) < 900;
      this.revokePendingImage();
      this.showCropModal = false;
    },
    onCropCancel() {
      this.revokePendingImage();
      this.showCropModal = false;
    },
    revokePendingImage() {
      if (this.pendingImageSrc) {
        URL.revokeObjectURL(this.pendingImageSrc);
        this.pendingImageSrc = null;
      }
    },
    onFileChangeCopyRight(e) {
      const file = e.target.files[0];
      this.input.copyRightFile = this.getExt(file.name) == 'pdf' ? file : URL.createObjectURL(file);
      this.copyRightFileName = file.name;
    },
    async onFileUploadSong(e) {
      const file = e.target.files[0];
      const fileTypeAllowed = ['audio/mp3', 'audio/mpeg', 'audio/MPA', 'audio/mpa-robust'];
      if (fileTypeAllowed.includes(file.type)) {
        try {
          const i = this.input.musics.length + 1;
          const fileTemp = await this.uploadFile(file, i);
          const musicInfo = file.name.split('-');
          const data = {
            content_id: 0,
            id: fileTemp.data.key,
            type: 'new',
            title: musicInfo[0].replaceAll(/_/ig, ' ') || '',
            fileMusicPreview: URL.createObjectURL(file),
            price: 0,
            price_dollar: 0,
            track_number: i,
            language: null,
            composer: '',
            is_cover: 0,
            original_artist_name: '',
            original_artist_info: '',
            tag: '',
          };
          this.input.musics.push(data);
          this.orderedTrackNumber.push(data.track_number);
          this.listTrackNumbers = Array.from({ length: this.input.musics.length }, (_, i) => i + 1);
        } catch (e) {
          this.$swal('Error', e.data.message, 'error');
        }
      } else {
        this.$swal('Error', 'File format must be mp3', 'error');
      }
    },
    getExt(name) {
      const fileInfo = name.split('.');
      return fileInfo[fileInfo.length - 1];
    },
    changeImage() {
      this.input.artwork = null;
      this.isImageTooSmall = false;
    },
    changeCopyRight() {
      this.input.copyRightFile = null;
    },
    async onDrop(e) {
      const fileTypeAllowed = ['audio/mp3', 'audio/mpeg', 'audio/MPA', 'audio/mpa-robust'];
      this.dragover = false;
      let errorFiles = '';
      let uploadIterate = i;
      let i = this.input.musics.length + 1;
      for (const file of e.dataTransfer.files) {
        if (fileTypeAllowed.includes(file.type)) {
          try {
            const fileTemp = await this.uploadFile(file, uploadIterate);
            const musicInfo = file.name.split('-');
            const data = {
              content_id: 0,
              id: fileTemp.data.key,
              type: 'new',
              title: musicInfo[0].replaceAll(/_/ig, ' ') || '',
              fileMusicPreview: URL.createObjectURL(file),
              price: 0,
              price_dollar: 0,
              track_number: this.input.musics.length + 1,
              language: null,
              composer: '',
              is_cover: 0,
              original_artist_name: '',
              original_artist_info: '',
              tag: '',
            };
            this.input.musics.push(data);
            this.orderedTrackNumber.push(data.track_number);
            i++;
          } catch (e) {
            errorFiles += `File: ${file.name}. Error: ${e.data.message}<br />`;
          }
          uploadIterate++;
        }
      }
      if (this.input.musics.length > 0) {
        this.listTrackNumbers = Array.from({ length: this.input.musics.length }, (_, i) => i + 1);
      }
      if (errorFiles !== '') {
        this.$swal('Error', errorFiles, 'error');
      }
    },
    async uploadFile(file, index) {
      this.setLoadingWithMessage(`uploading file ${index}: 0%`);
      const dataSong = new FormData();
      dataSong.append('file', file);
      const res = await this.requestAddSongFileTemp({ file: dataSong,
        callback: (event) => {
          const percentCompleted = Math.round((100 * event.loaded) / event.total);
          this.setLoadingWithMessage(`uploading file ${index}: ${percentCompleted}%`);
        } });
      return res;
    },
    changeTrackNumber(event, index) {
      const oldVal = this.orderedTrackNumber[index];
      const newVal = this.input.musics[index].track_number;
      const indexReplace = this.orderedTrackNumber.findIndex(m => m === newVal);
      this.input.musics[indexReplace].track_number = oldVal;
      this.orderedTrackNumber[index] = newVal;
      this.orderedTrackNumber[indexReplace] = oldVal;
    },
    convertPrice(index) {
      this.input.musics[index].price_dollar = !isNaN(this.input.musics[index].price) ?
        parseFloat(this.toCredit(this.input.musics[index].price)).toFixed(2) : 0;
    },
    removeTracks(index) {
      if (this.input.musics[index].type === 'old') {
        this.deletedTrack.push(this.input.musics[index].content_id);
      }
      this.input.musics.splice(index, 1);
      this.orderedTrackNumber = Array.from({ length: this.input.musics.length }, (_, i) => i + 1);
      this.listTrackNumbers = Array.from({ length: this.input.musics.length }, (_, i) => i + 1);
      this.input.musics.forEach((m, index) => {
        m.track_number = index + 1;
      });
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileAudio.data;
    },
    addCategory() {
      this.input.genreList.push({
        id: null,
      });
    },
    removeCategory(index) {
      this.input.genreList.splice(index, 1);
    },
  },
  components: { FormItem, Input, TextArea, Button, TextError, Select, ImageCropModal },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
.drag-drop{
  height: 300px;
  background: #E5E5EA;
}
.drag-drop-content{
  top:30%;
  left: 0;
  align-items: center;
}
.icon-drag-drop{
  font-size: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/Album/EditAlbum.vue